// @flow
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { StyledGridRow } from '@src/common-utils/styledComponents';
import { SPSPNameContainer } from '@streaming-projects/sp-page/sp-details/SPSPNameContainer';
import { PaddedAndRaisedSegment } from '@presentational/PaddedAndRaisedSegment';
import { useUpdateStreamingProjectMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { Spacer } from '@presentational/spacing/Spacer';
import { GenericSaveResetButtons } from '@components/GenericSaveResetButtons';
import { SPBaselineStartDateContainer } from '@streaming-projects/baseline/SPBaselineStartDateContainer';
import { SPBaselineEndDateContainer } from '@streaming-projects/baseline/SPBaselineEndDateContainer';
import { STREAMING_PROJECTS_BASELINE_DETAILS_CONFIG } from '@streaming-projects/baseline/config';
import { STREAMING_PROJECT_NAME_CONFIG } from '@streaming-projects/sp-page/config';

export const SPBaselineSPGenericDetailsContainer = () => {
  const { orgId, spId } = useParams();
  const [updateStreamingProjectDetails] = useUpdateStreamingProjectMutation();
  const spSPData = useContext(SPStreamingProjectContext);

  return (
    <>
      <PaddedAndRaisedSegment>
        <Grid columns={2} divided={true}>
          <StyledGridRow coloumns={2}>
            <Grid.Column>
              <SPSPNameContainer />
            </Grid.Column>
          </StyledGridRow>
          <StyledGridRow coloumns={2}>
            <Grid.Column>
              <SPBaselineStartDateContainer showWarningOnChange={true} />
            </Grid.Column>
            <Grid.Column>
              <SPBaselineEndDateContainer showWarningOnChange={true} />
            </Grid.Column>
          </StyledGridRow>
        </Grid>
        <Spacer y={40} />
        <GenericSaveResetButtons
          fieldsConfig={[
            ...STREAMING_PROJECTS_BASELINE_DETAILS_CONFIG.filter(
              (x) => x.backendFieldName !== 'input_file'
            ),
            STREAMING_PROJECT_NAME_CONFIG,
          ]}
          onSaveHandler={async (payload) => {
            return await updateStreamingProjectDetails({
              orgId,
              spId,
              payload: {
                ...payload,
                org_id: orgId,
                sp_id: spId,
                version: spSPData?.sp?.version,
              },
            });
          }}
        />
      </PaddedAndRaisedSegment>
    </>
  );
};
